export const rollbar = {
    name: 'Rollbar',
    key: 'rollbar',
    assets: {
        icon: '/images/competitors/rollbar.svg',
    },
    products: {
        product_analytics: {
            available: false,
        },
        session_replay: {
            available: false,
        },
        surveys: {
            available: false,
        },
        error_tracking: {
            available: true,
            features: {
                console_log_capture: true,
                error_alerts: true,
                error_grouping: true,
                exception_capture: true,
                issue_management: true,
                log_management: false,
                mobile_sdk_coverage: true,
                profiling: false,
                source_map_support: true,
                stack_tracing: true,
                user_device_context: true,
            },
            monitoring: {
                features: {
                    cron_monitoring: '',
                    distributed_tracing: false,
                    release_tracking: true,
                    performance_monitoring: false,
                },
            },
            integrations: {
                product_analytics: false,
                session_replay: false,
            },
        },
    },
    platform: {
        deployment: {
            eu_hosting: false,
            managed_reverse_proxy: false,
            open_source: false,
            self_host: false,
        },
        pricing: {
            free_tier: true,
            model: 'Usage-based',
            self_serve: true,
            transparent_pricing: false,
            usage_based_pricing: true,
        },
        developer: {
            api: false,
            collaboration: false,
            mobile_sdks: false,
            native_data_sources: false,
            proxies: false,
            sdks: false,
            server_side_sdks: false,
            sql: false,
        },
        tools: {
            cms: '',
            notebooks: false,
            project_management_tools: '',
        },
        integrations: {
            azure_blob: false,
            bigquery: false,
            cdp: false,
            ci_cd_integrations: true,
            community_integrations: false,
            csv_exports: false,
            customer_io: false,
            data_warehouse: false,
            datadog: false,
            email_reports: false,
            exports: false,
            gcs: false,
            google_ads: false,
            hubspot: false,
            imports: false,
            intercom: false,
            microsoft_teams: false,
            redshift: false,
            rudderstack: false,
            s3: false,
            salesforce: false,
            segment: false,
            sentry: false,
            slack: false,
            snowflake: false,
            stripe: false,
            warehouse_import: false,
            wordpress: false,
            zapier: false,
            zendesk: false,
        },
        security: {
            bot_blocking: false,
            cookieless_tracking: false,
            data_anonymization: false,
            data_retention: false,
            gdpr_ready: false,
            hipaa_ready: false,
            history_audit_logs: 'Enterprise',
            reverse_proxy: false,
            role_based_access_control: true,
            saml_sso: false,
            soc2_certified: false,
            two_factor_auth: false,
            user_privacy_options: false,
        },
        analytics_integration: {
            built_in_analytics: false,
        },
    },
}
